import { createMockConversationDebugResponse as e } from "./ConversationInspectorResource.mocks.js";
import { API as t, Resource as n } from "@coveo/platform-client";
//#region src/resources/conversation-inspector/ConversationInspectorResource.ts
var r = class extends n {
	static {
		this.baseUrl = `/rest/organizations/${t.orgPlaceholder}/conversations`;
	}
	getConversationDebug(t) {
		return e(t);
	}
};
//#endregion
export { r as ConversationInspectorResource };

//# sourceMappingURL=ConversationInspectorResource.js.map